import { FilterOption } from '@components/abb-table/abb-table.component';
import { getDaysInRange } from '@utils/datetime';

export enum RANGE {
  WEEK,
  MONTH,
  TRIMESTER,
  YEAR,
  ONLY,
}
export const resolutionSelectOptions = {
  [RANGE.WEEK]: ['1', '2'],
  [RANGE.MONTH]: ['1', '3'],
  [RANGE.TRIMESTER]: ['1', '4'],
  [RANGE.YEAR]: ['1', '5', '6'],
  [RANGE.ONLY]: ['7'],
};

const isSameDay = (date1: Date, date2: Date): boolean => {
  // Use UTC methods to avoid timezone offset issues
  const d1Year = date1.getUTCFullYear();
  const d1Month = date1.getUTCMonth();
  const d1Date = date1.getUTCDate();

  const d2Year = date2.getUTCFullYear();
  const d2Month = date2.getUTCMonth();
  const d2Date = date2.getUTCDate();

  return d1Year === d2Year && d1Month === d2Month && d1Date === d2Date;
};

export const getResolutionSelectOptions = (
  options: FilterOption[],
  fromDate: Date,
  toDate: Date
) => {
  if (isSameDay(fromDate, toDate)) {
    const filteredOptions = options.filter((o) =>
      resolutionSelectOptions[RANGE.ONLY].includes(o.value?.toString())
    );
    return filteredOptions;
  }

  const totDays = getDaysInRange(fromDate, toDate);
  console.log('Different days, totDays:', totDays);

  if (totDays < 28) {
    return options.filter((o) =>
      resolutionSelectOptions[RANGE.WEEK].includes(o.value?.toString())
    );
  } else if (totDays >= 28 && totDays < 89) {
    return options.filter((o) =>
      resolutionSelectOptions[RANGE.MONTH].includes(o.value?.toString())
    );
  } else if (totDays >= 89 && totDays < 365) {
    return options.filter((o) =>
      resolutionSelectOptions[RANGE.TRIMESTER].includes(o.value?.toString())
    );
  } else {
    return options.filter((o) =>
      resolutionSelectOptions[RANGE.YEAR].includes(o.value?.toString())
    );
  }
};
